<template>
  <div class="contact-modal">
    <div class="modal-header">
      <span>修改密码</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <div class="form-item">
        <div class="form-item-label">原&nbsp;&nbsp;密&nbsp;&nbsp;码：</div>
        <div class="form-item-value" :class="formData.originalPassword.error ? 'error' : ''">
          <input type="password" placeholder="请输入原密码" v-model="formData.originalPassword.value" />
          <div class="error-tip">{{formData.originalPassword.error}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">新&nbsp;&nbsp;密&nbsp;&nbsp;码：</div>
        <div class="form-item-value" :class="formData.newPassword.error ? 'error' : ''">
          <input type="password" placeholder="请输入新密码" v-model="formData.newPassword.value" />
          <div class="error-tip">{{formData.newPassword.error}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">确认密码：</div>
        <div class="form-item-value" :class="formData.confirmPassword.error ? 'error' : ''">
          <input type="password" placeholder="请输入确认密码" v-model="formData.confirmPassword.value" />
          <div class="error-tip">{{formData.confirmPassword.error}}</div>
        </div>
      </div>
      <hr>
      <div class="notice-tip">
        <img src="../../../assets/images/icon-tip.png" alt="" class="icon-notice" />
        <div>密码必须为6-16位，字母、数字或字符的组合</div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="confirm">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        originalPassword: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.formData.originalPassword.error = '请输入原密码';
              return false;
            }
            return true;
          }
        },
        newPassword: {
          value: '',
          error: false,
          validate: v => {
            const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
            if (!v) {
              this.formData.newPassword.error = '请输入新密码';
              return false;
            }
            if (!reg.test(v)) {
              this.formData.newPassword.error = '密码必须为6-16位，字母、数字或字符的组合';
              return false;
            }
            return true;
          }
        },
        confirmPassword: {
          value: '',
          error: false,
          validate: v => {
            if (v !== this.formData.newPassword.value) {
              this.formData.confirmPassword.error = '两次输入的密码不一致';
              return false;
            }
            return true;
          }
        },
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      for(let key in this.formData) {
        const field = this.formData[key];
        if (field.validate && !field.validate(field.value)) {
          return false;
        }
        field.error = false;
      }
      this.$emit('confirm', this.formData);
    }
  }
}
</script>

<style lang="less" scoped>
.contact-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }
      }
    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>